import { useState } from "react";

export default function AddUser({ onAdd }) {
    const [name, setName] = useState("");

    const handleAdd = () => {
        if (!name) return;

        onAdd(name);
        setName("");
    };

    return (
        <div className="flex gap-2 mb-4">
            <input
                className="flex-1 border p-2 rounded dark:bg-gray-700 dark:text-white"
                value={name}
                onChange={(e) => setName(e.target.value)}
                onKeyDown={(e) => {
                    if (e.key === "Enter") handleAdd();
                }}
                placeholder="New user"
            />

            <button
                onClick={handleAdd}
                className="bg-green-500 hover:bg-green-600 text-white p-3 rounded-2xl"
            >
                Add
            </button>
        </div>
    );
}
